'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtMainCategoryMyAsset(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtMainCategoryMyAsset');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.74 8.23998H11.88V1.77998H9.45997V19.72H11.88V10.56H13.74V20.16H16.22V1.47998H13.74V8.23998ZM2.93997 14.86V2.75998H0.339966V17.2H3.33997C5.07997 17.2 6.61997 17.12 8.35997 16.78L8.11997 14.54C6.37997 14.78 4.91997 14.86 3.65997 14.86H2.93997Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1457 8.23998V1.47998H35.6057V20.16H38.1457V10.56H40.8457V8.23998H38.1457ZM29.5657 5.19998H33.4457V2.85998H23.3057V5.19998H27.0657V5.73998C27.0657 9.71998 25.5657 12.78 22.5657 16L24.3857 17.66C26.0257 15.96 27.2657 14.2 28.1257 12.34L32.2457 17.48L34.1657 15.82L29.1257 9.51998C29.4257 8.29998 29.5657 7.05998 29.5657 5.73998V5.19998Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8106 1.47998H54.2506V15.3H56.8106V8.21998H59.5106V5.89998H56.8106V1.47998ZM51.3106 12.42L52.7706 10.52L47.8506 6.67998C48.1506 5.71998 48.3106 4.69998 48.3106 3.59998V2.13998H45.8106V3.59998C45.8106 6.29998 44.5706 8.63998 41.2706 10.84L42.7306 12.8C44.5306 11.6 45.8706 10.32 46.7906 8.89998L51.3106 12.42ZM44.5306 14.12V20.16H57.6906V17.84H47.0706V14.12H44.5306Z",
    fill: fill || 'black'
  }));
}
var IcTxtMainCategoryMyAsset$1 = /*#__PURE__*/memo(IcTxtMainCategoryMyAsset);

export { IcTxtMainCategoryMyAsset$1 as default };
